import React from "react";



import { EnhancedSlotsStatsSection } from "./enhanced-sections/enhanced-slots-stat";

import { EnhancedLoungeStatsSection } from "./enhanced-sections/enhanced-lounge-stat";
import { EnhancedRoomsStatsSection } from "./enhanced-sections/enhanced-rooms-stat";
import { EnhancedAISessionsStatsSection } from "./enhanced-sections/enhanced-ai-sessions-stat";

import { EnhancedUserGrowthSection } from "./enhanced-sections/enhanced-user-growth-section";
import { EnhancedSessionsSection } from "./enhanced-sections/enhanced-sessions-section";
import { EnhancedBookingsSection } from "./enhanced-sections/enhanced-bookings-section";

import { EnhancedFilterState } from "../pages/enhanced-dashboard";

type Props = {
  filters: EnhancedFilterState;
};

export const EnhancedSections: React.FC<Props> = ({ filters }) => {

  return (
    <div className="space-y-8">
      {/* Trend Sections - Now Separated into 4 Distinct Sections */}
      <section id="stats-users" className="scroll-mt-36">
        <EnhancedUserGrowthSection filters={filters} />
      </section>

      <section id="stats-sessions" className="scroll-mt-36">
        <EnhancedSessionsSection filters={filters} />
      </section>

      <section id="stats-bookings" className="scroll-mt-36">
        <EnhancedBookingsSection filters={filters} />
      </section>

      {/* Individual Sections with Enhanced Filters */}
      <section id="stats-slots" className="scroll-mt-36">
        <EnhancedSlotsStatsSection filters={filters} />
      </section>

      <section id="stats-lounge" className="scroll-mt-36">
        <EnhancedLoungeStatsSection filters={filters} />
      </section>

      <section id="stats-rooms" className="scroll-mt-36">
        <EnhancedRoomsStatsSection />
      </section>

      <section id="stats-ai-sessions" className="scroll-mt-36">
        <EnhancedAISessionsStatsSection />
      </section>
    </div>
  );
};
